import { Component, OnInit } from '@angular/core';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentService } from '../services/agent.service';
import { AgentProfileHandlerComponent } from './agent-profile.handler';
import { ActivatedRoute, Router } from '@angular/router';
declare const loadScrollbar: any;
@Component({
  selector: 'sym-agent-profile',
  templateUrl: './agent-profile.component.html',
  styleUrls: ['./agent-profile.component.scss'],
})
export class AgentProfileComponent extends AgentProfileHandlerComponent implements OnInit {
  breadCrumbList: BreadCrumb[];
  constructor(
    agentService: AgentService,
    public settingService: SettingService,
    public headerService: HeaderService,
    public router: Router,
    public route: ActivatedRoute
  ) {
    super(agentService, settingService,router,route);
  }

  ngOnInit() {
    this.breadCrumbList = [];
    this.breadCrumbList = this.getBreadCrumbList();
    this.getPageHeader();

    setTimeout(() => {
      loadScrollbar($('.scrollDiv'));
    }, 10);
    super.ngOnInit();
  }

  private getPageHeader() {
    this.headerService.pageHeader = new PageHeader();
    this.headerService.pageHeader.title = 'Profile';
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'home',
        link: '/home',
      },
      {
        id: 'Profile',
        link: '/profile',
      },
    ];
  }
}
